import { ReactNode } from "react";

import { useCohort } from "@/components/user-context";

import {
    ExistingUser as DefaultExistingUser,
    ManagedUser as DefaultManagedUser,
    NewUser as DefaultNewUser
} from "./components";

export const SiteActivationSwitcher = ({
    ExistingUser = <DefaultExistingUser />,
    ManagedUser = <DefaultManagedUser />,
    NewUser = <DefaultNewUser />
}: {
    ExistingUser?: ReactNode;
    ManagedUser?: ReactNode;
    NewUser?: ReactNode;
}) => {
    const cohort = useCohort();
    switch (cohort) {
        case "existing-user":
            return ExistingUser;
        case "managed-user":
            return ManagedUser;
        case "new-user":
            return NewUser;
        //   case "week-one-user":
        //     return <ContactExpandSiteActivation/>;
        default:
            return null;
    }
};
